/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { ProjectChangesSettingsControllerFindOneQueryResponse, ProjectChangesSettingsControllerFindOnePathParams, ProjectChangesSettingsControllerFindOneQueryParams, ProjectChangesSettingsControllerFindOne400, ProjectChangesSettingsControllerFindOne401, ProjectChangesSettingsControllerFindOne403, ProjectChangesSettingsControllerFindOne404 } from "../../models/changeOrdersController/ProjectChangesSettingsControllerFindOne";
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from "@tanstack/react-query";
import { projectChangesSettingsControllerFindOne } from "../../clients/change-ordersService/projectChangesSettingsControllerFindOne";
import { queryOptions, useQuery } from "@tanstack/react-query";
export const projectChangesSettingsControllerFindOneQueryKey = (projectId: ProjectChangesSettingsControllerFindOnePathParams["projectId"], params: ProjectChangesSettingsControllerFindOneQueryParams = {}) => [{
  url: '/api/v1/project-changes-settings/:projectId',
  params: {
    projectId: projectId
  }
}, ...(params ? [params] : [])] as const;
export type ProjectChangesSettingsControllerFindOneQueryKey = ReturnType<typeof projectChangesSettingsControllerFindOneQueryKey>;
export function projectChangesSettingsControllerFindOneQueryOptions(projectId: ProjectChangesSettingsControllerFindOnePathParams["projectId"], params?: ProjectChangesSettingsControllerFindOneQueryParams, config: Partial<RequestConfig> & {
  client?: typeof fetch;
} = {}) {
  const queryKey = projectChangesSettingsControllerFindOneQueryKey(projectId, params);
  return queryOptions<ProjectChangesSettingsControllerFindOneQueryResponse, ResponseErrorConfig<ProjectChangesSettingsControllerFindOne400 | ProjectChangesSettingsControllerFindOne401 | ProjectChangesSettingsControllerFindOne403 | ProjectChangesSettingsControllerFindOne404>, ProjectChangesSettingsControllerFindOneQueryResponse, typeof queryKey>({
    enabled: !!projectId,
    queryKey,
    queryFn: async ({
      signal
    }) => {
      config.signal = signal;
      return projectChangesSettingsControllerFindOne(projectId, params, config);
    }
  });
}

/**
 * @summary Get Changes settings for a project
 * {@link /api/v1/project-changes-settings/:projectId}
 */
export function useProjectChangesSettingsControllerFindOne<TData = ProjectChangesSettingsControllerFindOneQueryResponse, TQueryData = ProjectChangesSettingsControllerFindOneQueryResponse, TQueryKey extends QueryKey = ProjectChangesSettingsControllerFindOneQueryKey>(projectId: ProjectChangesSettingsControllerFindOnePathParams["projectId"], params?: ProjectChangesSettingsControllerFindOneQueryParams, options: {
  query?: Partial<QueryObserverOptions<ProjectChangesSettingsControllerFindOneQueryResponse, ResponseErrorConfig<ProjectChangesSettingsControllerFindOne400 | ProjectChangesSettingsControllerFindOne401 | ProjectChangesSettingsControllerFindOne403 | ProjectChangesSettingsControllerFindOne404>, TData, TQueryData, TQueryKey>> & {
    client?: QueryClient;
  };
  client?: Partial<RequestConfig> & {
    client?: typeof fetch;
  };
} = {}) {
  const {
    query: queryConfig = {},
    client: config = {}
  } = options ?? {};
  const {
    client: queryClient,
    ...queryOptions
  } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? projectChangesSettingsControllerFindOneQueryKey(projectId, params);
  const query = useQuery({
    ...projectChangesSettingsControllerFindOneQueryOptions(projectId, params, config),
    queryKey,
    ...queryOptions
  } as unknown as QueryObserverOptions, queryClient) as UseQueryResult<TData, ResponseErrorConfig<ProjectChangesSettingsControllerFindOne400 | ProjectChangesSettingsControllerFindOne401 | ProjectChangesSettingsControllerFindOne403 | ProjectChangesSettingsControllerFindOne404>> & {
    queryKey: TQueryKey;
  };
  query.queryKey = queryKey as TQueryKey;
  return query;
}